import type CustomReportChannel from '@/Enums/ReportBuilder/ReportChannel.enum';
import type { IEvent } from '@/Interfaces/Pixels/Event.interface';

export const CLIENTS_ENDPOINT = '/clients';
export const CLIENTS_LIST_ENDPOINT = '/clients/list';

export const WHITELABELS_ENDPOINT = '/whitelabels';
export const PUBLISHERS_ENDPOINT = '/publishers';
export const BEESWAX_CAMPAIGNS_ENDPOINT = '/beeswax/campaign';
export const EVENTS_ENDPOINT = '/beeswax-event';
export const eventsWithIdEndpoint = (id: IEvent['event_id']) => `${EVENTS_ENDPOINT}/${id}`;

export const GEO_BOUNDARIES = '/geo/boundaries';
export const GEO_JOINT_BOUNDARIES = '/geo/jointBoundaries';
export const GEO_TARGETING_SEARCH = '/geo/targeting/search';
export const GEO_TARGETING_LOCATIONS_LOOKUP = '/geo/targeting/locationsLookup';

export const ZIPCODE_ENDPOINT = 'https://vanitysoft-boundaries-io-v1.p.rapidapi.com/rest/v1/public/boundary/zipcode';

export const ZIPCODE_BY_COORDINATES_ENDPOINT =
  'https://vanitysoft-boundaries-io-v1.p.rapidapi.com/reaperfire/rest/v1/public/boundary/zipcode';

export const STATES_ENDPOINT =
  'https://vanitysoft-boundaries-io-v1.p.rapidapi.com/reaperfire/rest/v1/public/boundary/state/';

export const DMA_ENDPOINT = 'https://vanitysoft-boundaries-io-v1.p.rapidapi.com/reaperfire/rest/v1/public/boundary/dma';

//#region omnichannel reporting dashboard
export const REPORTING_BEESWAX_LOOKER_ENDPOINT = '/reportingDashboard/omnichannel/lookerQuery';
export const REPORTING_BEESWAX_CONTENT_DIMENSION_ENDPOINT = '/reportingDashboard/omnichannel/contentDimensionQuery';
//#endregion
//#region google reporting dashboard
export const REPORTING_GOOGLE_QUERY_ENDPOINT = '/reportingDashboard/google/query';
export const REPORTING_GOOGLE_REPORT_ENDPOINT = '/reportingDashboard/google/report';
//#endregion

export const CAMPAIGNS_ENDPOINT = '/campaigns';
export const CAMPAIGNS_LIST_ENDPOINT = '/campaigns/list';
export const EVENTS_LIST_ENDPOINT = '/events/list';
export const LINE_ITEMS_ENDPOINT = '/line-items';
export const SUPPORT_REQUEST_ENDPOINT = '/support/request';
export const ZENDESK_AUTH_ENDPOINT = '/zendesk/auth';
export const PRODUCTS_ENDPOINT = '/products';
export const PRODUCTS_BY_CHANNELS_ENDPOINT = '/products/by-channels';
export const PRODUCT_DOMAINS_ENDPOINT = (id: number) => `/products/${id}/domains`;
export const ADSWIZZ_PRODUCTS_ENDPOINT = '/reference/adswizzProducts';
export const CHANNELS_ENDPOINT = '/reference/channels';
export const AUDIENCES_ENDPOINT = '/reference/audiences';
export const AUDIENCES_BY_CHANNELS_ENDPOINT = '/reference/audiences-by-channels';
export const ADSWIZZ_AUDIENCES_ENDPOINT = '/reference/adswizzAudiences';
export const DV360_TICKETS_INSERTION_ORDERS_ENDPOINT = '/dv360-tickets/insertion-orders';
export const DV360_TICKETS_PRODUCTS_ENDPOINT = '/dv360-tickets/products';
export const DV360_TICKETS_AUDIENCES_ENDPOINT = '/dv360-tickets/audiences';
export const DV360_TICKETS_LINE_ITEMS_ENDPOINT = '/dv360-tickets/line-items';
export const DV360_TICKETS_CREATIVES_ENDPOINT = '/dv360-tickets/creatives';
export const DV360_TICKETS_CREATIVES_PROCESS_ENDPOINT = (id: number) =>
  `${DV360_TICKETS_CREATIVES_ENDPOINT}/${id}/process`;

export const customReportsEndpoint = (channel: CustomReportChannel) => `/custom-reports/${channel}`;
export const scheduledCustomReportsEndpoint = (channel: CustomReportChannel) => `/scheduled-custom-reports/${channel}`;
export const customReportTemplatesEndpoint = (channel: CustomReportChannel) => `/custom-report-templates/${channel}`;

export const SCHEDULED_PDF_CUSTOM_REPORT_ENDPOINT = '/scheduled-pdf-custom-report';
export const PDF_CUSTOM_REPORT_TEMPLATES_ENDPOINT = '/pdf-custom-report-templates';
export const pdfCustomReportTemplateEndpoint = (id: number) => `/pdf-custom-report-templates/${id}`;
export const pdfCustomReportTemplateShareEndpoint = (id: number) => `/pdf-custom-report-templates/${id}/share`;
export const ALL_CUSTOM_REPORT_TEMPLATES_ENDPOINT = '/custom-report-templates';
export const customReportTemplateShareEndpoint = (id: number) => `/custom-report-templates/${id}/share`;
export const CUSTOM_REPORTS_YOUTUBE_CAMPAIGNS = '/custom-reports/youtube/campaigns';

export const CREATIVES_ENDPOINT = '/creatives';
export const CREATIVES_BULK_ENDPOINT = '/creatives/bulk';
export const CREATIVES_ARCHIVE_ENDPOINT = '/creatives/archive';

export const ADVERTISERS_ENDPOINT = '/advertisers';
export const ADVERTISER_CATEGORIES_ENDPOINT = '/beeswax/v2/ref/advertiser-categories';

export const FIRSTPARTY_ENDPOINT = '/firstparty';
export const FIRSTPARTY_UPLOAD_ENDPOINT = `${FIRSTPARTY_ENDPOINT}/upload`;

export const AGENCIES_ENDPOINT = '/agencies';

export const CHANGE_LOG_HISTORY_ENDPOINT = '/audit-logs';
export const CHANGE_LOG_HISTORY_EXPORT_ENDPOINT = `${CHANGE_LOG_HISTORY_ENDPOINT}/export`;
export const CHANGE_LOG_HISTORY_CHANGES_ENDPOINT = (id: number) => `${CHANGE_LOG_HISTORY_ENDPOINT}/${id}/changes`;

export const STORAGE_GET_SIGNED_URL_ENDPOINT = '/storage/signed-url';

export const FORECASTER_PREVIEW_ENDPOINT = '/forecaster/preview';

export const FORECASTER_GAM_AD_UNITS_ENDPOINT = '/forecaster/gam/ad-units';
export const FORECASTER_GAM_SUB_AD_UNITS_ENDPOINT = (topId: string) => `/forecaster/gam/ad-units/${topId}/children`;
export const FORECASTER_GAM_CREATIVE_SIZES_ENDPOINT = '/forecaster/gam/creative-sizes';

//#region attribution
export const ATTRIBUTION_BEESWAX_LOOKER_ENDPOINT = '/attribution/beeswax/lookerQuery';
//#endregion

export const REPORT_ENDPOINT = '/pacing/beeswax/report/v2';

export const DOOH_REPORT_ENDPOINT = '/reportingDashboard/dooh/report';
export const DOOH_CAMPAIGNS_ENDPOINT = '/reportingDashboard/dooh/campaigns';
export const ADSWIZZ_REPORT_ENDPOINT = '/adswizz/report';

export const NOTIFICATIONS_ENDPOINT = '/notifications';
